import { userRequest } from "../../RequestMethods";
import { wishlistActionAddSuccess, wishlistActionFailure, wishlistActionStart } from "../wishlistRedux";

export const addWishlistItem = async (dispatch, item) => {
  dispatch(wishlistActionStart());
  await userRequest
    .post("/wishlist/addWishlistItem", item)
    .then((resp) => {
      dispatch(wishlistActionAddSuccess(resp.data));
    })
    .catch((err) => {
      console.error(err)
      dispatch(wishlistActionFailure());
    });
};

export const getAllWishlistItems = async (dispatch) => {
  dispatch(wishlistActionStart());
  await userRequest
    .get("/wishlist/getAllWishlistItems")
    .then((resp) => {
      dispatch(wishlistActionAddSuccess(resp.data));
    })
    .catch((err) => {
      console.error(err)
      dispatch(wishlistActionFailure());
    });
};

export const deleteWishlistItem = async (dispatch, id) => {
  dispatch(wishlistActionStart());
  await userRequest
    .delete("/wishlist/deleteWishlistItem/" + id)
    .then((resp) => {
      dispatch(wishlistActionAddSuccess(resp.data));
    })
    .catch((err) => {
      console.error(err)
      dispatch(wishlistActionFailure());
    });
};

export const updateWishlistItem = async (dispatch, product) => {
  dispatch(wishlistActionStart());
  let config = {
    headers: {
      query: JSON.stringify(product)
    }
  }
  await userRequest
    .patch("/wishlist/updateWishlistItem", '', config)
    .then((resp) => {
      dispatch(wishlistActionAddSuccess(resp.data));
    })
    .catch((err) => {
      console.error(err)
      dispatch(wishlistActionFailure());
    });
};